import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const TossResultMob = () => {
  return <CommonResult />;
};

export default TossResultMob;
